// // import React, { useState } from 'react';
// // import { Link } from 'react-router-dom';
// // import { X, ArrowRight, Mail, User, Building2, Phone } from 'lucide-react';
// // import { Button } from './ui/button';

// // const SignupModal = ({ isOpen, onClose }) => {
// //   const [formData, setFormData] = useState({
// //     firstName: '',
// //     lastName: '',
// //     email: '',
// //     company: '',
// //     phone: '',
// //     agreeToTerms: false
// //   });

// //   const handleInputChange = (e) => {
// //     const { name, value, type, checked } = e.target;
// //     setFormData(prev => ({
// //       ...prev,
// //       [name]: type === 'checkbox' ? checked : value
// //     }));
// //   };

// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     if (!formData.agreeToTerms) {
// //       alert('Please agree to the Terms & Conditions and Privacy Policy');
// //       return;
// //     }
// //     console.log('Form submitted:', formData);
// //     alert('Account created successfully! Welcome to AALIGN.');
// //     onClose();
// //     // Reset form
// //     setFormData({
// //       firstName: '',
// //       lastName: '',
// //       email: '',
// //       company: '',
// //       phone: '',
// //       agreeToTerms: false
// //     });
// //   };

// //   const handleGoogleSignIn = () => {
// //     console.log('Google Sign In clicked');
// //     alert('Google Sign In will be integrated here');
// //   };

// //   if (!isOpen) return null;

// //   return (
// //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
// //       <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
// //         {/* Header */}
// //         <div className="sticky top-0 bg-gradient-to-r from-orange-500 to-red-600 text-white p-6 rounded-t-3xl flex justify-between items-center">
// //           <div>
// //             <h2 className="text-2xl font-bold">Start Your Free Trial</h2>
// //             <p className="text-orange-100 text-sm mt-1">30 days • No credit card required</p>
// //           </div>
// //           <button onClick={onClose} className="text-white hover:text-gray-200">
// //             <X className="w-6 h-6" />
// //           </button>
// //         </div>

// //         {/* Form */}
// //         <form onSubmit={handleSubmit} className="p-6 space-y-4">
// //           {/* Name Fields */}
// //           <div className="grid sm:grid-cols-2 gap-4">
// //             <div>
// //               <label className="block text-sm font-semibold text-gray-700 mb-2">
// //                 First Name <span className="text-red-600">*</span>
// //               </label>
// //               <div className="relative">
// //                 <User className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
// //                 <input
// //                   type="text"
// //                   name="firstName"
// //                   value={formData.firstName}
// //                   onChange={handleInputChange}
// //                   required
// //                   className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
// //                   placeholder="John"
// //                 />
// //               </div>
// //             </div>
// //             <div>
// //               <label className="block text-sm font-semibold text-gray-700 mb-2">
// //                 Last Name <span className="text-red-600">*</span>
// //               </label>
// //               <div className="relative">
// //                 <User className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
// //                 <input
// //                   type="text"
// //                   name="lastName"
// //                   value={formData.lastName}
// //                   onChange={handleInputChange}
// //                   required
// //                   className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
// //                   placeholder="Doe"
// //                 />
// //               </div>
// //             </div>
// //           </div>

// //           {/* Email */}
// //           <div>
// //             <label className="block text-sm font-semibold text-gray-700 mb-2">
// //               Email <span className="text-red-600">*</span>
// //             </label>
// //             <div className="relative">
// //               <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
// //               <input
// //                 type="email"
// //                 name="email"
// //                 value={formData.email}
// //                 onChange={handleInputChange}
// //                 required
// //                 className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
// //                 placeholder="john.doe@company.com"
// //               />
// //             </div>
// //           </div>

// //           {/* Company */}
// //           <div>
// //             <label className="block text-sm font-semibold text-gray-700 mb-2">
// //               Company Name <span className="text-red-600">*</span>
// //             </label>
// //             <div className="relative">
// //               <Building2 className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
// //               <input
// //                 type="text"
// //                 name="company"
// //                 value={formData.company}
// //                 onChange={handleInputChange}
// //                 required
// //                 className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
// //                 placeholder="Your Company"
// //               />
// //             </div>
// //           </div>

// //           {/* Phone */}
// //           <div>
// //             <label className="block text-sm font-semibold text-gray-700 mb-2">
// //               Phone Number (Optional)
// //             </label>
// //             <div className="relative">
// //               <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
// //               <input
// //                 type="tel"
// //                 name="phone"
// //                 value={formData.phone}
// //                 onChange={handleInputChange}
// //                 className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
// //                 placeholder="+1 234 567 8900"
// //               />
// //             </div>
// //           </div>

// //           {/* Terms and Conditions */}
// //           <div className="flex items-start gap-2">
// //             <input
// //               type="checkbox"
// //               name="agreeToTerms"
// //               checked={formData.agreeToTerms}
// //               onChange={handleInputChange}
// //               required
// //               className="mt-1 w-4 h-4 text-orange-600 border-gray-300 rounded focus:ring-orange-500"
// //             />
// //             <label className="text-sm text-gray-600">
// //               I agree to the{' '}
// //               <Link to="/terms-and-conditions" className="text-orange-600 hover:text-orange-700 font-semibold" onClick={onClose}>
// //                 Terms & Conditions
// //               </Link>{' '}
// //               and{' '}
// //               <Link to="/privacy-policy" className="text-orange-600 hover:text-orange-700 font-semibold" onClick={onClose}>
// //                 Privacy Policy
// //               </Link>
// //             </label>
// //           </div>

// //           {/* Submit Button */}
// //           <Button
// //             type="submit"
// //             className="w-full bg-gradient-to-r from-orange-500 to-red-600 text-white hover:from-orange-600 hover:to-red-700 font-bold py-4 rounded-lg flex items-center justify-center gap-2"
// //           >
// //             Create Account
// //             <ArrowRight className="w-5 h-5" />
// //           </Button>
// //         </form>

// //         {/* Divider */}
// //         <div className="relative px-6">
// //           <div className="absolute inset-0 flex items-center">
// //             <div className="w-full border-t border-gray-300"></div>
// //           </div>
// //           <div className="relative flex justify-center text-sm">
// //             <span className="px-4 bg-white text-gray-500 font-semibold">OR</span>
// //           </div>
// //         </div>

// //         {/* Google Sign In */}
// //         <div className="p-6 pt-4">
// //           <button
// //             type="button"
// //             onClick={handleGoogleSignIn}
// //             className="w-full flex items-center justify-center gap-3 px-4 py-3 border-2 border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-semibold text-gray-700"
// //           >
// //             <svg className="w-5 h-5" viewBox="0 0 24 24">
// //               <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
// //               <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
// //               <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
// //               <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
// //             </svg>
// //             Sign in with Google
// //           </button>

// //           {/* Login Links */}
// //           <div className="mt-4 text-center text-sm text-gray-600">
// //             <p className="mb-2">Already have an account?</p>
// //             <div className="flex items-center justify-center gap-4">
// //               <a
// //                 href="https://portal.aalign.io/login"
// //                 className="text-orange-600 hover:text-orange-700 font-semibold"
// //               >
// //                 Login as Agency
// //               </a>
// //               <span className="text-gray-400">|</span>
// //               <a
// //                 href="https://portal.aalign.io/partner/login"
// //                 className="text-orange-600 hover:text-orange-700 font-semibold"
// //               >
// //                 Login as Partner
// //               </a>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default SignupModal;


// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom'; // Added useNavigate
// import { X, ArrowRight, Mail, User, Building2, Phone } from 'lucide-react';
// import { Button } from './ui/button';
// import { toast } from '../hooks/use-toast'; // Import your toast

// const SignupModal = ({ isOpen, onClose }) => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false); // Added loading state
  
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     company: '',
//     phone: '',
//     agreeToTerms: false
//   });

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!formData.agreeToTerms) {
//       toast({ title: "Terms Required", description: "Please agree to the Terms & Conditions.", variant: "destructive" });
//       return;
//     }

//     setLoading(true);

//     try {
//       // API CALL INTEGRATION
//       const response = await fetch("https://portal.aalign.io/services/signup.ashx", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           first_name: formData.firstName,
//           last_name: formData.lastName,
//           email: formData.email,
//           company: formData.company, // Sent but depends on if your API accepts it
//           phone: formData.phone
//         }),
//       });

//       const result = await response.json();

//       // Check for success (either a new ID or "email exists" logic)
//       if (result.account_id || (result.error && result.error.toLowerCase().includes("exist"))) {
//         toast({ 
//           title: "Success!", 
//           description: "Please check your email for verification." 
//         });
        
//         onClose(); // Close the modal
//         navigate("/"); // Redirect to home or a success page
        
//         // Reset form
//         setFormData({ firstName: '', lastName: '', email: '', company: '', phone: '', agreeToTerms: false });
//       } else {
//         toast({
//           title: "Signup Failed",
//           description: result.error || "Something went wrong.",
//           variant: "destructive",
//         });
//       }
//     } catch (error) {
//       toast({
//         title: "Network Error",
//         description: "Could not reach server. Try again later.",
//         variant: "destructive",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGoogleSignIn = () => {
//     window.location.href = "https://portal.aalign.io/login"; // Redirecting to actual login
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
//       <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
//         {/* Header */}
//         <div className="sticky top-0 bg-gradient-to-r from-orange-500 to-red-600 text-white p-6 rounded-t-3xl flex justify-between items-center z-10">
//           <div>
//             <h2 className="text-2xl font-bold">Start Your Free Trial</h2>
//             <p className="text-orange-100 text-sm mt-1">30 days • No credit card required</p>
//           </div>
//           <button onClick={onClose} className="text-white hover:text-gray-200">
//             <X className="w-6 h-6" />
//           </button>
//         </div>

//         {/* Form */}
//         <form onSubmit={handleSubmit} className="p-6 space-y-4">
//           <div className="grid sm:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">First Name *</label>
//               <div className="relative">
//                 <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
//                 <input
//                   type="text"
//                   name="firstName"
//                   value={formData.firstName}
//                   onChange={handleInputChange}
//                   required
//                   className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
//                   placeholder="John"
//                 />
//               </div>
//             </div>
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">Last Name *</label>
//               <div className="relative">
//                 <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
//                 <input
//                   type="text"
//                   name="lastName"
//                   value={formData.lastName}
//                   onChange={handleInputChange}
//                   required
//                   className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
//                   placeholder="Doe"
//                 />
//               </div>
//             </div>
//           </div>

//           <div>
//             <label className="block text-sm font-semibold text-gray-700 mb-2">Email *</label>
//             <div className="relative">
//               <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleInputChange}
//                 required
//                 className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
//                 placeholder="john@company.com"
//               />
//             </div>
//           </div>

//           <div>
//             <label className="block text-sm font-semibold text-gray-700 mb-2">Company Name *</label>
//             <div className="relative">
//               <Building2 className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
//               <input
//                 type="text"
//                 name="company"
//                 value={formData.company}
//                 onChange={handleInputChange}
//                 required
//                 className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
//                 placeholder="Your Company"
//               />
//             </div>
//           </div>

//           <div>
//             <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number</label>
//             <div className="relative">
//               <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
//               <input
//                 type="tel"
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleInputChange}
//                 className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
//                 placeholder="+1 234 567 8900"
//               />
//             </div>
//           </div>

//           <div className="flex items-start gap-2">
//             <input
//               type="checkbox"
//               name="agreeToTerms"
//               checked={formData.agreeToTerms}
//               onChange={handleInputChange}
//               required
//               className="mt-1 w-4 h-4 text-orange-600 border-gray-300 rounded"
//             />
//             <label className="text-sm text-gray-600">
//               I agree to the <Link to="/terms-and-conditions" className="text-orange-600 font-semibold" onClick={onClose}>Terms</Link> and <Link to="/privacy-policy" className="text-orange-600 font-semibold" onClick={onClose}>Privacy Policy</Link>.
//             </label>
//           </div>

//           <Button
//             type="submit"
//             disabled={loading}
//             className="w-full bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold py-4 rounded-lg flex items-center justify-center gap-2"
//           >
//             {loading ? "Creating account..." : "Create Account"}
//             {!loading && <ArrowRight className="w-5 h-5" />}
//           </Button>
//         </form>

//         <div className="relative px-6 py-2">
//           <div className="absolute inset-0 flex items-center px-6"><div className="w-full border-t border-gray-300"></div></div>
//           <div className="relative flex justify-center text-sm"><span className="px-4 bg-white text-gray-500 font-semibold">OR</span></div>
//         </div>

//         <div className="p-6 pt-2">
//           <button
//             type="button"
//             onClick={handleGoogleSignIn}
//             className="w-full flex items-center justify-center gap-3 px-4 py-3 border-2 border-gray-300 rounded-lg hover:bg-gray-50 font-semibold text-gray-700"
//           >
//             <img src="https://www.svgrepo.com/show/355037/google.svg" className="w-5 h-5" alt="Google" />
//             Sign in with Google
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignupModal;

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { X, ArrowRight, Mail, User, Building2, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from '../hooks/use-toast';

const SignupModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    phone: '',
    agreeToTerms: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.agreeToTerms) {
      toast({ title: "Terms Required", description: "Please agree to the Terms & Conditions.", variant: "destructive" });
      return;
    }
    setLoading(true);
    try {
      const response = await fetch("https://portal.aalign.io/services/signup.ashx", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
          company: formData.company,
          phone: formData.phone
        }),
      });
      const result = await response.json();

      if (result.account_id || (result.error && result.error.toLowerCase().includes("exist"))) {
        toast({ title: "Success!", description: "Account created successfully." });
        onClose();
        navigate("/");
      } else {
        toast({ title: "Error", description: result.error, variant: "destructive" });
      }
    } catch (error) {
      toast({ title: "Network Error", description: "Try again later.", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden border border-gray-100">
        
        {/* Compact Header */}
        <div className="bg-gradient-to-r from-orange-500 to-red-600 text-white p-5 flex justify-between items-center">
          <div>
            <h2 className="text-xl font-bold">Start Your Free Trial</h2>
            <p className="text-orange-100 text-xs opacity-90">30 days • No credit card required</p>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-white/20 rounded-full transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Scroll-free Form Body */}
        <div className="p-5">
          <form onSubmit={handleSubmit} className="space-y-3">
            
            {/* Names Row */}
            <div className="grid grid-cols-2 gap-3">
              <div className="relative">
                <User className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  required
                  value={formData.firstName}
                  onChange={handleInputChange}
                  className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                />
              </div>
              <div className="relative">
                <User className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  required
                  value={formData.lastName}
                  onChange={handleInputChange}
                  className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                />
              </div>
            </div>

            {/* Email */}
            <div className="relative">
              <Mail className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                required
                value={formData.email}
                onChange={handleInputChange}
                className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
              />
            </div>

            {/* Company & Phone Row (Side-by-side to save space) */}
            <div className="grid grid-cols-2 gap-3">
              <div className="relative">
                <Building2 className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                <input
                  type="text"
                  name="company"
                  placeholder="Company"
                  required
                  value={formData.company}
                  onChange={handleInputChange}
                  className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                />
              </div>
              <div className="relative">
                <Phone className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 outline-none"
                />
              </div>
            </div>

            {/* Terms */}
            <div className="flex items-center gap-2 py-1">
              <input
                type="checkbox"
                name="agreeToTerms"
                checked={formData.agreeToTerms}
                onChange={handleInputChange}
                required
                className="w-4 h-4 accent-orange-500 cursor-pointer"
              />
              <label className="text-[11px] text-gray-500 leading-tight">
                I agree to the <Link to="/terms-and-conditions" className="text-orange-600 font-bold">Terms</Link> & <Link to="/privacy-policy" className="text-orange-600 font-bold">Privacy Policy</Link>.
              </label>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold py-5 rounded-lg text-sm shadow-md active:scale-[0.98] transition-transform"
            >
              {loading ? "Creating Account..." : "Create Free Account"}
            </Button>
          </form>

          {/* Divider */}
          <div className="relative my-4">
            <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-gray-200"></div></div>
            <div className="relative flex justify-center text-[10px] uppercase tracking-widest"><span className="px-3 bg-white text-gray-400 font-bold">OR</span></div>
          </div>

          {/* Google Button - High Visibility */}
          <button
            type="button"
            onClick={() => window.location.href = 'https://portal.aalign.io/login'}
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 font-semibold text-gray-700 text-sm transition-colors"
          >
            <img src="https://www.svgrepo.com/show/355037/google.svg" className="w-4 h-4" alt="Google" />
            Sign in with Google
          </button>

          {/* Bottom Link */}
          <p className="mt-4 text-center text-xs text-gray-500">
            Already have an account? 
            <a href="https://portal.aalign.io/login" className="text-orange-600 font-bold ml-1 hover:underline">Login</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignupModal;